import { Component, OnInit, ViewChild} from '@angular/core';
import { AuthenticationService, GlobalInfoService } from '@app/core';
import { SystemUsersComponent } from './system-users/system-users.component';
import { Const } from "@app/shared";

@Component({
  selector: 'iw-groups-permissions',
  templateUrl: './groups-permissions.component.html',
  styleUrls: ['./groups-permissions.component.scss']
})
export class GroupsPermissionsComponent implements OnInit {

  @ViewChild(SystemUsersComponent) user: SystemUsersComponent;

  tabSystemUsers = false;
  tabsGroupPermision = false;
  tabGroupsAdministrationReports = false;
  
  constructor(
    private gis: GlobalInfoService,
    private as: AuthenticationService,
  ) { }

  ngOnInit() {
    // se setea el titulo de la vista actual
    this.gis.set({ title: 'Gestión de Grupos y Permisos' });

    // Validacion de permisos sobre el tab usuarios
    this.tabSystemUsers = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.reviewUser,
    );

    // Validacion de permisos sobre el tab usuarios
    this.tabsGroupPermision = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions,
      Const.types_action_permissions.review,
    );

    this.tabGroupsAdministrationReports = this.as.confirmPermission(
      Const.types_permissions.groupsAdministrationForReports,
      Const.types_action_permissions.reviewReport
    );
  }

  tabClick(idTab: string, event: any) {
    if(idTab == 'tabSystemUsers' && event != undefined && event.id != undefined && event.id == 'tabSystemUsers'){
      this.activatedConsulting();
    };
  }

  public activatedConsulting() {
    this.user.startConsulting()
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/groups-permissions.component.ts